import { Loop } from "@mui/icons-material";
import {
  IconButton,
  lighten,
  styled,
  Tooltip,
  Typography,
} from "@mui/material";

export const StyledFeatureLabel = {
  LabelContainer: styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: 20,
    padding: 5,
    backgroundColor: theme.palette.primary.main,
    borderRadius: 10,
    border: `2px solid ${lighten(theme.palette.primary.main, 0.2)}`,
    color: "white",
  })),
  Icon: styled(IconButton)(({ theme, vibrar }) => ({
    color: "white",
    cursor: "pointer",
    fontSize: "large",
    marginLeft: 10,
    ...(vibrar && {
      transition: "transform 0.2s ease-in-out",
      animation: "vibrar 0.5s ease-in-out",
      "@keyframes vibrar": {
        "0%": {
          transform: "rotate(-15deg)",
        },
        "50%": {
          transform: "rotate(15deg)",
        },
        "100%": {
          transform: "rotate(0deg)",
        },
      },
    }),
  })),
  LabelText: styled("div")(({ theme }) => ({
    paddingLeft: 10,
  })),
};

export const StyledTitleWithFetchData = {
  Container: styled("div")({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
  }),
  Title: styled(Typography)({
    marginRight: "16px",
  }),
  StyledLoopIcon: styled(Loop)({
    color: "#1f1f42",
    "&:hover, &:focus": {
      cursor: "pointer",
    },
  }),
};

export const StyledMessageTooltip = {
  Container: styled("div")({
    backgroundColor: "#ff5c5c",
    borderRadius: 10,
    margin: 5,
    paddingLeft: 5,
    padding: 2,
  }),
  HtmlTooltip: styled(Tooltip)({
    tooltip: {
      backgroundColor: "rgba(0,0,0, 0.7)",
      borderRadius: 10,
      padding: 1,
    },
  }),
};
